module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('h3', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "file-input-container"
  }, [_c('div', {
    staticClass: "file-input-wrapper"
  }, [_c('div', {
    staticClass: "input-label"
  }, [_vm._v("Choose your file:")]), _vm._v(" "), _c('input', {
    ref: "videoInput",
    attrs: {
      "type": "file",
      "name": "videoInput",
      "id": "videoInput",
      "size": _vm.maxSize,
      "accept": _vm.extensions.join(',')
    },
    on: {
      "change": function($event) {
        _vm.filesChange($event.target.files)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "file-label",
    attrs: {
      "for": "logoInput"
    }
  }, [(_vm.isClean) ? _c('span', [_c('i', {
    staticClass: "fas fa-file"
  }), _vm._v(" Choose a file... (Max\n          " + _vm._s(_vm.maxFileSize) + "Mb)\n        ")]) : _vm._e(), _vm._v(" "), (!_vm.isClean) ? _c('span', [_vm._v(_vm._s(_vm.fileName) + " selected... ")]) : _vm._e(), _vm._v(" "), (_vm.hasError) ? _c('span', {
    staticClass: "alert-box"
  }, [_vm._v("\n          " + _vm._s(_vm.error) + "\n        ")]) : _vm._e()])]), _vm._v(" "), (_vm.source) ? _c('div', {
    staticClass: "preview-container"
  }, [_c('div', {
    staticClass: "vid-delete",
    attrs: {
      "title": "Delete video"
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearVideo
    }
  }, [_c('i', {
    staticClass: "fas fa-times fw"
  })])]), _vm._v(" "), (!_vm.isImage) ? _c('video', {
    key: _vm.fileKey,
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.source,
      "type": _vm.sourceType,
      "id": "videoPreview"
    }
  }), _vm._v("\n        Your browser does not support HTML5 video.\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isImage) ? _c('img', {
    staticClass: "preview-image",
    attrs: {
      "src": _vm.source
    }
  }) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.isSuccessful) ? _c('div', {
    staticClass: "success-message"
  }, [_c('p', [_vm._v("Thanks for submitting your creation to defend the Unburnt Six.")]), _vm._v(" "), _c('p', [_vm._v("Take the next step in helping us to Regenerate Australia by signing up to plant a native tree.")]), _vm._v(" "), _c('a', {
    staticClass: "success-link",
    attrs: {
      "href": "https://www.wwf.org.au/what-we-do/regenerate-australia/regenerate-australia-hub"
    }
  }, [_vm._v("Plant a tree")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "submit-container"
  }, [_c('button', {
    attrs: {
      "type": "button",
      "disabled": _vm.isClean || _vm.hasError || _vm.isUploading
    },
    on: {
      "click": _vm.uploadVideo
    }
  }, [(!_vm.isUploading) ? _c('span', [_vm._v("Submit")]) : _vm._e(), _vm._v(" "), (_vm.isUploading) ? _c('span', [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d94d83e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=4ecaiejb649!./~/string-replace-webpack-plugin/loader.js?id=vjos074u90o!./src/components/forms/EdoVideoUpload.vue
// module id = 793
// module chunks = 0